export const putBrAfterClosingPTag = input => input.replace(/<br><\/p>/g, '</p><br>');
